import React, { useState, useEffect } from 'react';
import { View, StyleSheet, Platform } from 'react-native';

// Web shim for DateTimePicker - uses native HTML5 input
const DateTimePicker = ({ 
  value, 
  mode = 'date', 
  onChange, 
  display = 'default',
  minimumDate,
  maximumDate,
  ...props 
}) => {
  const [localValue, setLocalValue] = useState(value || new Date());

  useEffect(() => {
    if (value) {
      setLocalValue(value);
    }
  }, [value]);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    let newDate;

    if (mode === 'date') {
      newDate = new Date(inputValue + 'T00:00:00');
    } else if (mode === 'time') {
      const [hours, minutes] = inputValue.split(':');
      newDate = new Date(localValue);
      newDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    } else {
      // datetime
      newDate = new Date(inputValue);
    }

    // Check minimum/maximum date constraints
    if (minimumDate && newDate < minimumDate) {
      newDate = minimumDate;
    }
    if (maximumDate && newDate > maximumDate) {
      newDate = maximumDate;
    }

    setLocalValue(newDate);

    // Call onChange with the same signature as native DateTimePicker
    // Native passes (event, date) but we only need date
    if (onChange) {
      onChange({ nativeEvent: { timestamp: newDate.getTime() } }, newDate);
    }
  };

  const formatValue = () => {
    if (!localValue) return '';

    if (mode === 'date') {
      return localValue.toISOString().split('T')[0];
    } else if (mode === 'time') {
      const hours = localValue.getHours().toString().padStart(2, '0');
      const minutes = localValue.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    } else {
      // datetime-local
      const dateStr = localValue.toISOString().slice(0, 16);
      return dateStr;
    }
  };

  const inputType = mode === 'date' ? 'date' : mode === 'time' ? 'time' : 'datetime-local';

  return (
    <View style={styles.container}>
      <input
        type={inputType}
        value={formatValue()}
        onChange={handleChange}
        min={minimumDate ? formatValueForMinMax(minimumDate, mode) : undefined}
        max={maximumDate ? formatValueForMinMax(maximumDate, mode) : undefined}
        style={styles.input}
        {...props}
      />
    </View>
  );
};

const formatValueForMinMax = (date, mode) => {
  if (mode === 'date') {
    return date.toISOString().split('T')[0];
  } else if (mode === 'time') {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  } else {
    return date.toISOString().slice(0, 16);
  }
};

const styles = StyleSheet.create({
  container: {
    // Container for web styling if needed
  },
  input: {
    padding: 8,
    border: '1px solid #ccc',
    borderRadius: 4,
    fontSize: 16,
    fontFamily: 'inherit',
    ...(Platform.OS === 'web' && {
      width: '100%',
      boxSizing: 'border-box',
    }),
  },
});

export default DateTimePicker;

